import { Component, OnInit } from '@angular/core';


import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AccountService } from '../../../services/account.service';
import { AuthService } from "../../../services/auth.service";
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-setupup-password',
  templateUrl: './account-setupup-password.component.html',
  styleUrls: ['./account-setupup-password.component.css'],
  imports: []
})
export class AccountSetupupPasswordComponent implements OnInit {

  userId: string = "";
  resetToken: string = "";


  public constructor(private alertService: AlertService, private accountService: AccountService,
    private authService: AuthService, public router: Router, private activeRoute: ActivatedRoute) {

    // force route reload whenever params change;
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.userId = this.activeRoute.snapshot.params['userid'];
    this.resetToken = this.activeRoute.snapshot.params['resettoken'];

    console.log(this.userId + " " + this.resetToken)

    if (!this.userId || !this.resetToken || this.userId == "" || this.resetToken == "") {
      this.alertService.showMessage("Invalid Request.", "Something went wrong with the request!", MessageSeverity.error);
      this.router.navigateByUrl('/errorpage');

      //SOLUTION: SPLIT THE TOKEN IN SMALLER SIZE TOKENS

    }

  }

}

